import { render, staticRenderFns } from "./Jabatan.vue?vue&type=template&id=124af6f6&scoped=true"
import script from "./Jabatan.vue?vue&type=script&lang=js"
export * from "./Jabatan.vue?vue&type=script&lang=js"
import style0 from "./Jabatan.vue?vue&type=style&index=0&id=124af6f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124af6f6",
  null
  
)

export default component.exports